var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPredio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 18V18.25H20H21.75V19.75H0.25V18.25H2H2.25V18V1C2.25 0.801088 2.32902 0.610322 2.46967 0.46967C2.61032 0.329018 2.80109 0.25 3 0.25H19C19.1989 0.25 19.3897 0.329018 19.5303 0.46967C19.671 0.610322 19.75 0.801087 19.75 1V18ZM18 18.25H18.25V18V2V1.75H18H4H3.75V2V18V18.25H4H18ZM7.25 9.25H9.75V10.75H7.25V9.25ZM7.25 5.25H9.75V6.75H7.25V5.25ZM7.25 13.25H9.75V14.75H7.25V13.25ZM12.25 13.25H14.75V14.75H12.25V13.25ZM12.25 9.25H14.75V10.75H12.25V9.25ZM12.25 5.25H14.75V6.75H12.25V5.25Z",
    fill: "white",
    stroke: "#383A35",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPredio);
export default __webpack_public_path__ + "static/media/ico-predio.31fb71a45df37ecb53636a0488b82d55.svg";
export { ForwardRef as ReactComponent };